export default "__VITE_ASSET__CmrHRa$L__"